import { apiInstance } from 'api/utils';

export default {
  getSystemUpdates: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/releases'
    });
  },
  markUpdatesAsSeen: () => {
    return apiInstance.request({
      method: 'POST',
      url: '/mark-releases-seen/'
    });
  }
};
